export class ResetSessionState {
  static readonly type = '[Session] Reset Session State';
}
